export const EMAIL_VERIFICATION_CODE = 1004
export const GROUP_LIMIT_CODE = 1007
